import { Injectable } from '@angular/core';
import { UrlFactory } from './url-factory';

@Injectable({ providedIn: 'root' })
export class CpiGateway {
  constructor(private _urlFactory: UrlFactory) {}

  validateTokenUrl() {
    return this._urlFactory.createUrl('publicCpi', 'v1/validatetoken');
  }

  lyncNSyncUrl() {
    return this._urlFactory.createUrl('privateCpi', 'v1/lyncnsync');
  }

  getBrandingUrl() {
    return this._urlFactory.createUrl('privateCpi', 'v1/branding');
  }
}
